module.exports = __webpack_public_path__ + "static/media/gift.84a09fa4.png";